export enum PriorityType {
  Pregnant = 1,
  WheelChair = 2,
  Elder = 3,
  Autism = 4,
  Other = 5,
}

export const PriorityTypeDetails = {
  [PriorityType.Pregnant]: {
    labelKey: 'PORTAL.WAITING_LIST.PRIORITY.OPTIONS.PREGNANT',
    value: 'Pregnant',
  },
  [PriorityType.WheelChair]: {
    labelKey: 'PORTAL.WAITING_LIST.PRIORITY.OPTIONS.WHEELCHAIR',
    value: 'WheelChair',
  },
  [PriorityType.Elder]: {
    labelKey: 'PORTAL.WAITING_LIST.PRIORITY.OPTIONS.ELDERLY',
    value: 'Elder',
  },
  [PriorityType.Autism]: {
    labelKey: 'PORTAL.WAITING_LIST.PRIORITY.OPTIONS.AUTISTIC',
    value: 'Autism',
  },
  [PriorityType.Other]: {
    labelKey: 'PORTAL.WAITING_LIST.PRIORITY.OPTIONS.OTHER',
    value: 'Other',
  },
} as const;
